import { defaultDataTransformer } from '@aspectus/resource-commons'
import { createReceiver, createSender } from '@md/resources'
import { prefixAPI } from '@md/api'

const r = (tpl, f = createReceiver) =>
  f(prefixAPI(tpl)).transform(defaultDataTransformer)

export const tgChatApi = {
  // Список чатов
  list: r('/tg-chat/list/{?userId,leadId,identified,managerId}'),
  // Сообщения и отправка сообщений
  messages: {
    list: r('/tg-chat{/chatId}/messages/list/{?limit,offset,since_id}'),
    send: r('/tg-chat{/chatId}/actions/send/', createSender),
  },
  // Проверка статуса исходящего сообщения
  outgoing: {
    retrieve: r('/tg-chat/outgoing{/id}/retrieve/'),
  },
  // Привязка/перепривязка Telegram аккаунта клиента
  clients: {
    link: r('/tg-chat/clients/actions/link/', createSender),
  },
  // рекомендации существующих клиентов/лидов для привязки unidentified Telegram-чата
  suggestions: {
    list: r('/tg-chat/suggestions/list/{?phone,first_name,last_name}'),
  },
  // административные действия над конкретным Telegram-чатом
  chat: {
    link: r('/tg-chat{/chatId}/actions/link/', createSender),
    unlink: r('/tg-chat{/chatId}/actions/unlink/', createSender),
    // заменить одну существующую связь чата другой
    relink: r('/tg-chat{/chatId}/actions/relink/', createSender),
  },

  // запускаем скачивание remote Telegram-файла на backend
  download: r(
    '/tg-chat/messages{/id}/actions/download/',
    createSender
  ),
  // polling состояния скачивания файла
  downloadStatus: r(
    '/tg-chat/messages{/id}/download/retrieve/'
  ),

  // API для авторизации Telegram-аккаунта текущего менеджера
  auth: {
    status: r('/tg-chat/auth/status/retrieve/{?managerId}'),
    sendCode: r('/tg-chat/auth/actions/send-code/{?managerId}', createSender),
    signIn: r('/tg-chat/auth/actions/sign-in/{?managerId}', createSender),
    checkPassword: r('/tg-chat/auth/actions/check-password/{?managerId}', createSender),
    logout: r('/tg-chat/auth/actions/logout/{?managerId}', createSender),
  },
}